"use client"

import { useState } from "react"
import { Handle, Position } from "reactflow"
import NodeControls from "./NodeControls"
import "./Node.css"
import { Database } from "lucide-react"

const DataNode = ({ data, id }) => {
  const [expanded, setExpanded] = useState(false)
  const [dataSource, setDataSource] = useState(data.dataSource || "database")
  const [query, setQuery] = useState(data.query || "SELECT * FROM table")

  const toggleExpand = () => {
    setExpanded(!expanded)
  }

  return (
    <div className={`custom-node data-node ${expanded ? "expanded" : ""}`}>
      <NodeControls id={id} />

      <div className="node-header" onClick={toggleExpand}>
        <div className="node-icon">
          <Database size={16} />
        </div>
        <div className="node-title">{data.label}</div>
      </div>

      {expanded && (
        <div className="node-content">
          <div className="node-field">
            <label>Data Source</label>
            <select value={dataSource} onChange={(e) => setDataSource(e.target.value)}>
              <option value="database">Database</option>
              <option value="api">API</option>
              <option value="file">File</option>
            </select>
          </div>

          <div className="node-field">
            <label>Query</label>
            <textarea value={query} onChange={(e) => setQuery(e.target.value)} rows={3} />
          </div>
        </div>
      )}

      {/* Input handle at the top-left */}
      <div className="input-handle-container">
        <Handle
          type="target"
          position={Position.Left}
          id="b"
          className="connection-handle input-handle"
          style={{
            left: "-15px",
            top: "0",
            transform: "translateY(50%)",
          }}
        />
      </div>

      {/* Output handle at the top-right */}
      <div className="output-handle-container">
        <Handle
          type="source"
          position={Position.Right}
          id="a"
          className="connection-handle output-handle"
          style={{
            right: "-15px",
            top: "0",
            transform: "translateY(50%)",
          }}
        />
      </div>
    </div>
  )
}

export default DataNode
